import { useNavigate, useSearchParams } from "react-router-dom";
import loginFrame from "assets/login/login-main-frame.svg";
import hhsFrame from "assets/login/hhsBanner.png";
import { Label } from "components/ui/label";
import { Button } from "components/ui/button";
import Layout from "common/layout";
import config from "config";
import { createVerificationSession } from "services/api";
import { useContext, useState } from "react";
import { useNavigateWithQueryParams } from "utils/navigateWithQueryParams";
import { UserContext } from "context/userContext";
import { useNavigation } from "utils/onNavigate";

type Props = {
  isLogin?: boolean;
};

const Login = (props: Props) => {
  const [searchParams] = useSearchParams();
  const context: any = useContext(UserContext);
  const pageConfig: any = context?.pageConfiguration;
  const navigate = useNavigate();
  const { navigateToNextPage } = useNavigation();
  const { navigateWithQueryParams } = useNavigateWithQueryParams();
  const [loader, setLoader] = useState(false);
  const onRegister = async () => {
    setLoader(true);
    const payload: any = {
      ...config?.clientConfig,
      productGroupId: config?.clientConfig?.productGroupId,
    };
    const result: any = await createVerificationSession(payload);
    setLoader(false);
    context.setTokenParams(result?.token?.replace("?", ""));
    const params = `token=${result?.token?.replace("?", "")}${
      searchParams.get("skipAntispoof") ? "&skipAntispoof=true" : ""
    }`;
    if (pageConfig) {
      navigateToNextPage(params);
    } else {
      navigate(
        `/user-consent?token=${result?.token?.replace("?", "")}${
          searchParams.get("skipAntispoof") ? "&skipAntispoof=true" : ""
        }`
      );
    }
  };
  const bannerImage = pageConfig?.bannerImage ? pageConfig?.bannerImage : context?.themeHhs ? hhsFrame : loginFrame
  return (
    <Layout removeBorder={true} removeHeight={true}>
      <div
        className={`flex justify-center mt-8 ${
          context?.themeHhs
            ? "h-[300px] mb-10 max-md:h-[200px] max-md:w-[98%] max-md:m-auto"
            : "h-[361px] max-md:h-[330px]"
        }`}
      >
        <img
          src={bannerImage}
          alt=""
          data-src={bannerImage}
          className="lazyload"
        />
      </div>
      <div className="flex flex-col">
        <Label className="text-[44px] font-[Google Sans] font-[500] text-primaryText max-md:text-[28px]">
          {pageConfig?.title
            ? pageConfig?.title
            : props.isLogin
            ? "Log in with Private ID"
            : "Sign up with Private ID"}
        </Label>
        <Label className="mt-[15px] text-[16px] font-[Google Sans] font-[100] text-secondaryText max-md:text-[14px] max-md:w-[80%] max-md:m-auto max-md:mt-[7px]">
          {pageConfig?.subheading ||
            "A simple, fast and safe way to verify yourself."}{" "}
          <span className="cursor-pointer hover:underline">
            {pageConfig?.bannerLink || "Learn more."}
          </span>
        </Label>
      </div>
      <div className="mt-10 flex justify-center max-md:mt-6">
        <Button
          className="w-[65%] bg-primary rounded-[24px] text-[14px] hover:opacity-90 hover:bg-primary text-white max-md:w-[100%] max-md:max-w-[327px]"
          onClick={() => {
            if (props.isLogin) {
              navigateWithQueryParams("/login-options");
            } else {
              onRegister();
            }
          }}
          disabled={loader}
        >
          {pageConfig?.buttonText
            ? pageConfig?.buttonText
            : props.isLogin
            ? "Log in"
            : "Sign up"}
        </Button>
      </div>
      <div className="mt-5 flex justify-center">
        <Label className="mt-[16px] text-[16px] font-[Google Sans] font-[100] text-secondaryText">
          {props.isLogin
            ? "Don’t have an account?"
            : pageConfig?.accountText || "Already have an account?"}
        </Label>
        <Label
          className="mt-[16px] text-[16px] font-[Google Sans] text-primary hover:underline font-[500] ms-2 cursor-pointer"
          onClick={() => {
            if (props.isLogin) {
              navigateWithQueryParams("/", { token: undefined });
            } else {
              if (pageConfig) {
                navigateToNextPage("", "/login-options", "/");
              } else {
                navigateWithQueryParams("/login-options");
              }
            }
          }}
        >
          {pageConfig?.loginText
            ? pageConfig?.loginText
            : props.isLogin
            ? "Register"
            : "Log in"}
        </Label>
      </div>
    </Layout>
  );
};

export default Login;
